import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { JanelaSolicitacaoHonra } from './janela-solicitacao-honra.model';

export class AgenteFinanceiro extends BaseEntity {

    public id: number;
    public nome: string;
    public cnpj: string;
    public sigla: string;
    public possuiConglomerado?: boolean;
    public possuiHabilitacaoAlternativa?: boolean;

}

export class LoteAgenteFinanceiro {

    public agentesFinanceiros: AgenteFinanceiro[];

}

export class LoteAgenteFinanceiroJanela {

    public agentesFinanceiros: AgenteFinanceiro[];
    public janela: JanelaSolicitacaoHonra;

}
